export { AtnDsFloatingHorizontalTabsComponent as Component } from './floating-horizontal-tabs.component'
